import { getInitialAppVersion, normalizeAppVersion, versionsDiffer } from '../utils/app-version';

const initialVersion = getInitialAppVersion();

const initialState = {
    currentVersion: initialVersion,
    latestVersion: initialVersion,
    updateAvailable: false,
};

export const version = {
    namespaced: true,
    state: initialState,
    getters: {
        currentVersion: state => state.currentVersion,
        latestVersion: state => state.latestVersion,
        updateAvailable: state => state.updateAvailable,
    },
    actions: {
        initialize({ commit, state }, version = getInitialAppVersion()) {
            const normalizedVersion = normalizeAppVersion(version);

            if (!normalizedVersion) {
                return false;
            }

            if (
                state.currentVersion === normalizedVersion &&
                state.latestVersion === normalizedVersion &&
                !state.updateAvailable
            ) {
                return false;
            }

            commit('initialize', normalizedVersion);
            return true;
        },
        syncRemoteVersion({ commit, state }, version) {
            const normalizedVersion = normalizeAppVersion(version);

            if (!normalizedVersion) {
                return false;
            }

            if (!state.currentVersion) {
                commit('initialize', normalizedVersion);
                return false;
            }

            if (state.latestVersion === normalizedVersion) {
                return false;
            }

            commit('setLatestVersion', normalizedVersion);

            if (versionsDiffer(state.currentVersion, normalizedVersion)) {
                commit('setUpdateAvailable', true);
                return true;
            }

            return false;
        },
    },
    mutations: {
        initialize(state, version) {
            const normalizedVersion = normalizeAppVersion(version);
            state.currentVersion = normalizedVersion;
            state.latestVersion = normalizedVersion;
        },
        setLatestVersion(state, version) {
            state.latestVersion = normalizeAppVersion(version);
        },
        setUpdateAvailable(state, updateAvailable) {
            state.updateAvailable = updateAvailable;
        },
    },
};
